import APIService from '@/services/APIService';

export default {
  /**
   * Получить данные о выбинаре
   * https://gitlab.pfdo.ru/sdo/sdo/-/wikis/Работа%20с%20сущностями/Вебинар
   * @param id
   * @returns {Promise<AxiosResponse<T>>}
   */
  getWebinar(id) {
    return APIService.get(`/webinars/${id}`);
  },
  voteWebinar(id, score) {
    return APIService.post(`/webinars/${id}/vote`, { score });
  },
  getWebinarList(params) {
    const config = { params };
    return APIService.get('/webinars', config);
  },
  createWebinar(data) {
    return APIService.post('/webinars', data);
  },
  updateWebinar(id, data) {
    return APIService.put(`/webinars/${id}`, data);
  },
  deleteWebinar(id) {
    return APIService.delete(`/webinars/${id}`);
  },
};
